export default {
    new: 'New',
    used: 'Used',
    certified: '@:lexicon.certified',
    demo: 'Demo',
};
